import React from "react";
import { motion } from "framer-motion";
import { TEAM, OTHER_ASSOCIATED } from "./kvpData";
import KvpLayout, { CHARCOAL, COPPER, CREAM, SLATE } from "./KvpLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function KvpLawyers() {
  return (
    <KvpLayout active="lawyers">
      <section className="py-16 sm:py-20" style={{ background: CHARCOAL }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#E39A6E" }}>Our Lawyers</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">A Team With Depth</motion.h1>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-5xl mx-auto px-5 sm:px-8 grid sm:grid-cols-2 gap-6">
          {TEAM.map((t, i) => (
            <motion.div key={t.name} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.05 }} className="bg-white rounded-lg shadow-sm overflow-hidden flex">
              <img src={t.photo} alt={t.name} className="w-32 sm:w-36 object-cover object-top shrink-0" />
              <div className="p-5 flex flex-col justify-center">
                <p className="font-bold text-sm leading-snug" style={{ color: CHARCOAL }}>{t.name}</p>
                <p className="mt-1 text-xs font-semibold uppercase tracking-wide" style={{ color: COPPER }}>{t.role}</p>
                <p className="mt-2 text-xs" style={{ color: SLATE }}>{t.note}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <motion.p {...fadeUp} className="max-w-5xl mx-auto px-5 sm:px-8 mt-6 text-xs" style={{ color: SLATE }}>{OTHER_ASSOCIATED}</motion.p>
      </section>
    </KvpLayout>
  );
}
